通用勾选框

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-show="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <template v-if="isMuti">
      <el-tooltip class="el-checkbox__tooltip" effect="dark" :content="field.tooltipMsg" placement="top"
        v-if="field.isShowTooltip">
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-checkbox v-if="field.isShowAllBtn != false" v-model="chooseAll" @change="handleCheckAllChange"
        :disabled="isDisabled">全选</el-checkbox>
      <el-checkbox-group v-model="mutiDatas" @change="handleCheckedChange" :disabled="isDisabled">
        <el-checkbox v-for="(item, index) in options" :class="[
            'background-' + item.value,
            { 'el-checkbox--isCheckBox': isCheckBox },
            { 'has-save': item.hasSave == '1' },
	    { 'custom-checkBox': item.custom == '1' },
          ]" :key="index" border :label="item.value" :disabled="item.isDisable"
          @change="handleSingleChange($event, item.value)" :style="{ width: field.checkerWidth }">
          <span v-html="item.label"></span>
        </el-checkbox>
      </el-checkbox-group>
    </template>
    <el-checkbox v-else v-model="checked" :disabled="isDisabled" @change="handleChecked"></el-checkbox>
    <el-button class="use-id-button" v-if="isShowButton" @click="useCheckerButton">
      <i :class="field.DEFAULT_VALUE == '' ? 'el-icon-plus' : 'el-icon-refresh'"></i>
      {{ field.DEFAULT_VALUE == "" ? "选择银行" : "更换其他银行" }}
    </el-button>
  </el-form-item>
</template>

<script>
import { isString } from "util";

export default {
  data () {
    return {
      itemClass: "self-checker",
      checked: false,
      isDisabled: false,
      isMuti: false,  //是否是多个选项
      optionsAll: "",
      options: "",
      mutiDatas: [],  //当前多选选中的数据
      chooseAll: false,
      mutiDatasHistory: [], //多选框历史数据
      triggerType: "custom",//校验类型 custom是自定义的
      rules: [],
      isCheckBox: false //是否是多选
    };
  },
  props: ["field", "index", "groupId", "isBaseUI"],
  created () {
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
    if (typeof (this.field.DEFAULT_VALUE) == "string")
      this.mutiDatasHistory = _.cloneDeep(this.field).DEFAULT_VALUE.split(","); //保存勾选前的历史数据 以便反选

    if (this.isRequired)
      this.itemClass += " self-checker-required";

    if (this.isShowButton)
      this.itemClass += " self-checker-use-id-button";

    this.initData();
    this.initDict();
  },
  computed: {
    checkerClass: function () {
      return this.field.BUSI_CODE + "-check-all-box check-box-" + this.index;
    },
    title: function () {
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":", "？"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (this.isShowButton) {
        this.isDisabled = true;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    messageChange: function () {
      return this.field.message;
    },
    dictChange: function () {
      return this.field.FIELD_DICT_NAME;
    },
    dictFilterChange: function () {
      return this.field.FIELD_DICT_FILTER;
    },
    dictDisable: function () {
      return this.field.FIELD_DICT_DISABLE;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isShowButton: function () {
      return this.field.IS_SHOW_BUTTON;
    },
  },
  methods: {
    handleSingleChange (isChoose, value) {
      if (isChoose) {
        this.field.FIELD_LAST_CHOOSE_VALUE = value;
      } else {
        this.field.FIELD_LAST_CHOOSE_VALUE = "";
      }
    },
    handleCheckAllChange (v) {
      let checkAll = this.options.map(item => {
        return item.value;
      });
      // this.mutiDatas = v ? checkAll  : this.mutiDatasHistory;     //反选恢复之前的数据 有还原所用不用反选恢复
      this.mutiDatas = v ? checkAll : "";
      this.field.DEFAULT_VALUE = this.mutiDatas ? this.mutiDatas.join(",") : "";
      if (this.options.length == this.mutiDatas.length) {
        this.chooseAll = true;
      }
    },
    handleCheckedChange (v) {
      if (v.length == this.options.length) {//全选
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
      }
      this.field.DEFAULT_VALUE = v.join(",");
    },
    initDict () {
      if (this.isMuti && this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        this.optionsAll = [];
        this.options = [];
        let showArr;
        try {
          let filter = eval(this.field.FIELD_DICT_FILTER);
          if (filter.constructor == Array) {
            showArr = filter;
          } else {
            showArr = [];
          }
        } catch (exception) {
          showArr = [];
        }

        //展示但是不可编辑
        let disableArr = [];
        if (this.field.FIELD_DICT_DISABLE) {
          try {
            let disable = this.field.FIELD_DICT_DISABLE;
            disableArr = Array.isArray(disable) ? disable : isString(disable) ? disable.split(",") : [];
          } catch (exception) {
            disableArr = [];
          }
        }

        _.map(this.field.FIELD_DICT_NAME, (item) => {
          // 判断机构ORG_CODE TODO 不可编辑的要disable
          if (disableArr && disableArr.length > 0) {
            if (!_.isEmpty(_.find(disableArr, i => {
              return i == item.DICT_ITEM;
            }))) {
              item.IS_DISABLE = true;
            } else {
              item.IS_DISABLE = false;
            }
          } else if (this.field.FIELD_DICT_DISABLE && this.field.FIELD_DICT_DISABLE.length == 0) {
            item.IS_DISABLE = false;
          }
          this.optionsAll.push(this.getOptionItem(item));
        });

        if (showArr.length == 0 || showArr.length == this.field.FIELD_DICT_NAME.length) {
          this.options = this.optionsAll;
        } else {
          // 如果当前值不在过滤后的字典内，将当前值清掉
          // 有可能是多选 DEFAULT_VALUE是多个带有,的值 进行优化修改
          let DEFAULT_VALUE = this.field.DEFAULT_VALUE ? this.field.DEFAULT_VALUE.split(",") : "";
          let NEW_DEFAULT_VALUE = [];
          _.each(DEFAULT_VALUE, item => {
            if (_.indexOf(showArr, item) > -1) {
              NEW_DEFAULT_VALUE.push(item);
            }
          });
          this.field.DEFAULT_VALUE = NEW_DEFAULT_VALUE.join(",");

          _.filter(this.field.FIELD_DICT_NAME, (item) => {
            // 判断机构ORG_CODE TODO 
            for (let j = 0; j < showArr.length; j++) {
              if (item.DICT_ITEM == showArr[j]) {
                this.options.push(this.getOptionItem(item));
              }
            }
            this.optionsAll.push(this.getOptionItem(item));
          });
        }

        if (this.field.DEFAULT_VALUE && this.optionsAll.length == this.field.DEFAULT_VALUE.split(",").length) {
          this.chooseAll = true;
        }
      }
    },
    getOptionItem (item){
      return {
        "value": item.DICT_ITEM, 
        "label": item.DICT_ITEM_NAME, 
        "isDisable": item.IS_DISABLE ? item.IS_DISABLE : false, 
        "hasSave": item.hasSave ? item.hasSave : false ,
        "custom": item.custom ? item.custom : false 
      };
    },
    validatorField: function (rule, value, callback) {
      value = this.field.DEFAULT_VALUE;
      consoleLog("复选框 变化的新值", value);
      if (this.isBaseUI) { // 多选框选中和都不选中都广播值变更事件
        this.$emit("field-change", this.field);
      } else {
        this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
      }

      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        this.field.correct = true;
        this.showErrorMsg = "";
        this.field.message = "";
        this.field.showerr = false;
        return callback();
      }
    },
    initData () {
      if (this.field.DEFAULT_VALUE === "true") {
        this.checked = true;
        // this.field.DEFAULT_VALUE = "true";
        this.isMuti = false;
      } else if (this.field.DEFAULT_VALUE === "false") {
        this.checked = false;
        // this.field.DEFAULT_VALUE = "false";
        this.isMuti = false;
      } else if (this.field.DEFAULT_VALUE === false || this.field.DEFAULT_VALUE === true) {
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else if (this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME.length == 0 && this.field.DEFAULT_VALUE == "") {
        //如果默认值为空字符，而且没有设置字典项则视为单选
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else if (!this.field.FIELD_DICT_NAME && this.field.DEFAULT_VALUE == "") {
        this.checked = this.field.DEFAULT_VALUE;
        this.isMuti = false;
      } else { //多选
        this.isMuti = true;
        this.mutiDatas = this.field.DEFAULT_VALUE ? this.field.DEFAULT_VALUE.split(",") : [];
        // this.initDict();
      }
    },
    handleChecked (value) {
      this.field.DEFAULT_VALUE = "" + value;
    },
    //使用按钮
    useCheckerButton: function () {
      if (this.isBaseUI) {
        this.$emit("use-id-button", this.field);
      } else {
        //更改state的值，触发全局的字段赋值事件
        let data = {};
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.groupId;
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = "0";
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    }
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-checker-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-checker-required/g, "");
      }
    },

    messageChange: function (val) {
      // if(val){
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      // }
    },
    dictDisable () {

      this.initDict();
    },
    dictChange: {
      deep: true,
      handler: function (val) {
        this.initData();
        this.initDict();
      }
    },
    dataChange: function (val) {
      if (!!val && this.isMuti && this.field.FIELD_DICT_NAME && this.field.FIELD_DICT_NAME != "") {
        //值改变的时候判断是否在字典内
        let dict = this.field.FIELD_DICT_NAME || [];
        let valueArr = val.split(",");
        let newVal = [];
        _.forEach(valueArr, (v) => {
          let dictVal = _.find(dict, { DICT_ITEM: v }) || {};
          if (!_.isEmpty(dictVal)) {
            newVal.push(v);
          }
        });
        this.field.DEFAULT_VALUE = newVal.join(",");
      }
      this.field.message = "";
      this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      this.initData();
    },
    dictFilterChange: function (val) {
      this.initDict();
    }

  }
};
</script>

<style lang="less">
@import "~@/styles/less/variable.less";
.self-checker {
  width: 100%;
  display: flex;
  min-height: 200px;
  .el-form-item__label {
    font-size: 14px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 14px;    
    font-weight: 500;
    color: #232323;
    flex: 1;
    padding-top: 10px;
    .el-checkbox.is-bordered {
        margin-left: 2%;
        margin-top: 1%;
    }
    .el-checkbox {
      display: inline-flex;
      align-items: center;
      text-align: center;
      // width: 285px;
      width: 80%;
      height: 30px;
      background: #fff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      // .el-checkbox__label {
      //   .module-item-text();
      // }
      &.el-checkbox--isCheckBox {
        position: relative;
      }
      // &.is-checked {
      //   background: rgba(0, 108, 210, 0.2);
      //   border-color: #006cd2;
      //   .el-checkbox__label {
      //     color: #006cd2;
      //   }
      //   &.is-disabled {
      //     border-color: #006cd2;
      //   }
      // }
      // &.is-disabled {
      //   color: #b6bcc5;
      //   background-color: #ebecf2;
      //   border-color: #9fa2ae;
      //   .el-checkbox__label {
      //     color: inherit;
      //   }
      // }
      // &:first-child {
      //   margin-left: 0;
      // }
    }
    // .el-checkbox__input {
    //   vertical-align: bottom;
    //   display: none;
    // }
    // .el-checkbox__label {
    //   // font-size: 18px;原始vtm
    // font-size: 14px;
    //   // line-height: 50px;
    //   line-height: 60px;
    // }
    // .el-checkbox__inner {
    //   width: 36px;
    //   height: 36px;
    //   border-color: #aaaaaa;
    //   &::after {
    //     height: 20px;
    //     left: 11px;
    //     top: 2px;
    //     width: 12px;
    //     border-color: #fff;
    //   }
    //   &:hover {
    //     border-color: #9dcd17;
    //   }
    // }
    // .el-checkbox__input.is-checked .el-checkbox__inner,
    // .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    //   background-color: #9dcd17;
    //   border-color: #9dcd17;
    // }
    // .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    //   border-color: #fff;
    // }
    // .el-checkbox__input.is-checked + .el-checkbox__label {
    //   // color: inherit;
    // }
    // .el-checkbox__input.is-checked.is-disabled .el-checkbox__inner {
    //   background-color: #b0b0b0;
    //   border-color: #b0b0b0;
    // }
  }
}

.self-checker-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/checkerItem.vue